import { THEME_AZURE, normalizeThemeId } from '@/theme/screen-themes'

const STORAGE_KEY = 'safe-display-screen-theme'

const theme = {
  namespaced: true,
  state: {
    themeId: normalizeThemeId(localStorage.getItem(STORAGE_KEY) || THEME_AZURE)
  },
  getters: {
    themeId: state => state.themeId
  },
  mutations: {
    SET_THEME_ID (state, themeId) {
      state.themeId = normalizeThemeId(themeId)
      localStorage.setItem(STORAGE_KEY, state.themeId)
    }
  }
}

export default theme
